import React from 'react';
import OnboardingWizard from '../../components/onboarding/OnboardingWizard';
import useAuthStore from '../../store/authStore';
import useUserRole from '../../hooks/useUserRole';
import { Navigate } from 'react-router-dom';

const OnboardingPage = () => {
    const { user } = useAuthStore();
    const { userRole } = useUserRole();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Redirigir admins al dashboard
    if (userRole === 'ADMIN_ROLE') {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div className="min-h-screen bg-gray-50">
            <OnboardingWizard />
        </div>
    );
};

export default OnboardingPage; 